import script from "./SidePanel.vue?vue&type=script&setup=true&lang=js"
export * from "./SidePanel.vue?vue&type=script&setup=true&lang=js"

import "./SidePanel.vue?vue&type=style&index=0&id=6de7010a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6de7010a"]])

export default __exports__